import { Box, CircularProgress, Typography } from "@material-ui/core";
import { ICON_COLOUR } from "lib/constants/style_constants";
import { ToastMessageContext } from "lib/contexts/message_context";
import React, { useContext, useState } from "react";
import ViewIcon from "@material-ui/icons/Visibility";
import ReleaseCertPopup from "../ReleaseCertPopup";
import PartDetailsTable from "./PartDetailsTable";
import { format24HrDateTime } from "lib/utils/common_utils";

const GetInfoCard = (infoProps) => {
  return (
    <Box display="flex">
      <Typography style={{ fontSize: "14px", width: "17%" }} color="primary">
        {infoProps?.keyName}
      </Typography>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
        }}>
        {typeof infoProps?.value === "string" ? (
          <Typography
            style={{ fontSize: "14px", color: "#4D4F5C" }}
            variant="body2">
            {infoProps?.value ?? "-"}{" "}
          </Typography>
        ) : (
          infoProps?.value
        )}
      </Box>
    </Box>
  );
};

const StockReceipt = (props) => {
  const { data, releaseDetails, isGettingDetails, releaseDocuments } = props;

  const [isRelease, setIsRelease] = useState(false);
  const [multipleDocs, setMultipleDocs] = useState([]);

  const message = useContext(ToastMessageContext);

  const handleOpenSingleDocument = (docs, errorMessage) => {
    if (docs?.length > 0) {
      const link = docs[0]?.file_path;
      window.open(link, "_blank");
    } else {
      message.showToastMessage({
        message: errorMessage,
        variant: "error",
      });
    }
  };

  const handleOpenMultipleDocuments = (docs) => {
    setIsRelease(true);
    setMultipleDocs(
      docs?.map((item) => ({
        ...item,
        url: item.file_path,
      })) || []
    );
  };

  if (isGettingDetails) {
    return (
      <Box
        width="100%"
        minHeight="400px"
        display="flex"
        justifyContent="center"
        alignItems="center">
        <CircularProgress color="primary" size={40} />
      </Box>
    );
  }

  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
      <Box display="flex" flexDirection={"column"} style={{ gap: "0.75rem" }}>
        <Typography
          variant="body1"
          style={{
            fontSize: "17px",
          }}
          color="primary">
          Documentation
        </Typography>

        <Box
          style={{
            borderRadius: "8px",
            padding: "17px 24px",
            gap: "0.5rem",
            backgroundColor: "#F5F5F5",
            display: "flex",
            flexDirection: "column",
          }}>
          <GetInfoCard
            keyName={"Serviceable Label"}
            value={
              releaseDocuments?.serviceable_label?.length > 0 ? (
                <ViewIcon
                  style={{ cursor: "pointer" }}
                  fontSize="small"
                  htmlColor={ICON_COLOUR}
                  onClick={() => {
                    handleOpenSingleDocument(
                      releaseDocuments?.serviceable_label,
                      "No Label Found"
                    );
                  }}
                />
              ) : (
                "N/A"
              )
            }
          />
          <GetInfoCard
            keyName={"Workshop Report"}
            value={
              releaseDocuments?.workshop_report?.length > 0 ? (
                <ViewIcon
                  style={{ cursor: "pointer" }}
                  fontSize="small"
                  htmlColor={ICON_COLOUR}
                  onClick={() => {
                    handleOpenSingleDocument(
                      releaseDocuments?.workshop_report,
                      "No Report Found"
                    );
                  }}
                />
              ) : (
                "N/A"
              )
            }
          />
          <GetInfoCard
            keyName={"C of C"}
            value={
              releaseDocuments?.c_of_c?.length > 0 ? (
                <ViewIcon
                  style={{ cursor: "pointer" }}
                  fontSize="small"
                  htmlColor={ICON_COLOUR}
                  onClick={() => {
                    handleOpenSingleDocument(
                      releaseDocuments?.c_of_c,
                      "No File Found"
                    );
                  }}
                />
              ) : (
                "N/A"
              )
            }
          />
          <GetInfoCard
            keyName={"Release Cert1 "}
            value={
              releaseDocuments?.release_cert_1 &&
                Array.isArray(releaseDocuments?.release_cert_1) &&
                releaseDocuments?.release_cert_1?.length > 0 ? (
                <div style={{ marginTop: "3px" }}>
                  <ViewIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleOpenMultipleDocuments(
                        releaseDocuments?.release_cert_1
                      );
                    }}
                    fontSize="small"
                    htmlColor={ICON_COLOUR}
                  />
                </div>
              ) : (
                "N/A"
              )
            }
          />
          <GetInfoCard
            keyName={"Release Cert2 "}
            value={
              releaseDocuments?.release_cert_2 &&
                Array.isArray(releaseDocuments?.release_cert_2) &&
                releaseDocuments?.release_cert_2?.length > 0 ? (
                <div style={{ marginTop: "3px" }}>
                  <ViewIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleOpenMultipleDocuments(
                        releaseDocuments?.release_cert_2
                      );
                    }}
                    fontSize="small"
                    htmlColor={ICON_COLOUR}
                  />
                </div>
              ) : (
                "N/A"
              )
            }
          />
          <GetInfoCard
            keyName={"Scrap Cert"}
            value={
              releaseDocuments?.scrap_certificate?.length > 0 ? (
                <ViewIcon
                  style={{ cursor: "pointer" }}
                  fontSize="small"
                  htmlColor={ICON_COLOUR}
                  onClick={() => {
                    handleOpenSingleDocument(
                      releaseDocuments?.scrap_certificate,
                      "No Label Found"
                    );
                  }}
                />
              ) : (
                "N/A"
              )
            }
          />
          <GetInfoCard
            keyName={"Unserviceable Label"}
            value={
              releaseDocuments?.unserviceable_label?.length > 0 ? (
                <ViewIcon
                  style={{ cursor: "pointer" }}
                  fontSize="small"
                  htmlColor={ICON_COLOUR}
                  onClick={() => {
                    handleOpenSingleDocument(
                      releaseDocuments?.unserviceable_label,
                      "No Label Found"
                    );
                  }}
                />
              ) : (
                "N/A"
              )
            }
          />
        </Box>
      </Box>

      <Box display="flex" flexDirection={"column"} style={{ gap: "0.75rem" }}>
        <Typography
          variant="body1"
          style={{
            fontSize: "17px",
          }}
          color="primary">
          Part Details
        </Typography>

        <PartDetailsTable data={data} />
      </Box>

      <Box display="flex" flexDirection={"column"} style={{ gap: "0.75rem" }}>
        <Typography
          variant="body1"
          style={{
            fontSize: "17px",
          }}
          color="primary">
          Receipt Details
        </Typography>

        <Box
          style={{
            borderRadius: "8px",
            padding: "17px 24px",
            gap: "0.5rem",
            backgroundColor: "#F5F5F5",
            display: "flex",
            flexDirection: "column",
          }}>
          <GetInfoCard
            keyName={"Received By"}
            value={releaseDetails?.packed_by_userstamp || "-"}
          />
          <GetInfoCard
            keyName={"Received"}
            value={releaseDetails?.packed_at ? format24HrDateTime(releaseDetails?.packed_at) : "-"}
          />
        </Box>
      </Box>

      {isRelease && (
        <ReleaseCertPopup
          dialogCloseHandler={() => setIsRelease(false)}
          open={isRelease}
          msds={multipleDocs}
          title={"Release Certificates"}
        />
      )}
    </Box>
  );
};

export default StockReceipt;
